export const pvsystActions = {

    setInputData: ({ commit }, inputData) => {
        commit('SET_INPUT_DATA', inputData)
    },
    setGlobalIncline: ({ commit }, globalIncline) => {
        commit('SET_GLOBAL_INCLINE', globalIncline)
    },
    setEnergieCompteurAC: ({ commit }, energieCompteurAC) => {
        commit('SET_ENERGIE_COMPTEUR_AC', energieCompteurAC)
    },

};

